<template>
  <div id="app">
    <TheHeader />
    <RouterView />
    <CtaSection />
    <TheFooter />
  </div>
</template>

<script>
import CtaSection from './components/cta-section'
import TheFooter from './components/the-footer'
import TheHeader from './components/the-header'

export default {
  name: 'App',
  components: {
    CtaSection,
    TheFooter,
    TheHeader,
  },
  computed: {
    showHookSection() {
      return this.$route.path === '/'
    },
  },
  watch: {
    $route(to) {
      const currentPath = to.path
      const showHookSection = currentPath === '/'
      document.querySelector('.hook').style.display = showHookSection ? 'block' : 'none'
      document.documentElement.scrollTop = window.innerHeight
    },
  },
}
</script>
<style lang="scss">
// global
@import './styles/main.scss';
</style>

<style lang="scss" scoped>
#app {
  margin: auto;
}
</style>
